import React, { Component } from 'react'
import styled from 'styled-components'
import { InView } from 'react-intersection-observer'

import { media } from '../theme'
import Preload from '../components/Preload'
import AspectRatio from '../components/AspectRatio'
import SpeechBubble from '../components/SpeechBubble'

import TextHomeEnergyTipsImage from '../assets/images/text--home-energy-tips.svg'
import CharacterPluggyForwardImage from '../assets/images/character--pluggy-forward@3x.png'
import CharacterKeoniBillImage from '../assets/images/character--keoni-bill@3x.png'
import HouseCharactersImage from '../assets/images/house--characters@3x.png'
import HouseBackgroundImage from '../assets/images/house--background@3x.png'
import Button from '../components/Button'

// Preload items
import RoomBathImage from '../assets/images/room--bath.png'
import RoomBedImage from '../assets/images/room--bed.png'
import RoomGarageImage from '../assets/images/room--garage.png'
import RoomKitchenImage from '../assets/images/room--kitchen.png'
import RoomLaundryImage from '../assets/images/room--laundry.png'
import RoomLivingImage from '../assets/images/room--living.png'
import RoomCityImage from '../assets/images/room--city.png'

const preloadItems = [
  RoomBathImage,
  RoomBedImage,
  RoomGarageImage,
  RoomKitchenImage,
  RoomLaundryImage,
  RoomLivingImage,
  RoomCityImage,
]

const CommonSpacing = styled.div`
  padding: ${(p) => p.theme.spacing(0)} ${(p) => p.theme.spacing(1)};

  ${media.greaterThan('medium')`
    padding: ${(p) => p.theme.spacing(1)} ${(p) => p.theme.spacing(2)};
  `};
`

const Container = styled.div`
  background: linear-gradient(to right, #155564, #274554);
  display: flex;
  flex-direction: column;
  max-width: 50rem;
  width: calc(100% + 2 * ${(p) => p.theme.spacing(1)});
  margin: -${(p) => p.theme.spacing(1)};

  ${media.greaterThan('medium')`
    margin: -${(p) => p.theme.spacing(3)} -${(p) => p.theme.spacing(1)};
  `};
`

const HomeEnergyTips = styled(CommonSpacing)`
  ${media.greaterThan('medium')`
    padding-top: ${(p) => p.theme.spacing(2)};
    padding-bottom: ${(p) => p.theme.spacing(1)};
  `};
`

const HomeEnergyTipsImage = styled.img`
  margin: 0 auto;
  height: ${(p) => p.theme.spacing(4)};
`

const LearnHowToReduce = styled(CommonSpacing)`
  background: linear-gradient(to right, #073342, #05161d);
  color: #c9e9ea;
  font-size: ${(p) => p.theme.fontSize(1)};
  padding-bottom: ${(p) => p.theme.spacing(1)};
  text-align: center;
  text-transform: uppercase;

  ${media.greaterThan('medium')`
    background: transparent;
    font-size: ${(p) => p.theme.fontSize(1.5)};
    padding-bottom: ${(p) => p.theme.spacing(2)};
    padding-top: 0;
  `};
`

const CharacterScene = styled(CommonSpacing)`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  padding-top: 0;

  ${media.greaterThan('medium')`
    height: ${(p) => p.theme.spacing(9)};
  `};
`

const CharacterScenePluggy = styled(CharacterScene)`
  background: linear-gradient(215deg, #0a6b78, #b7d89c);
  margin-bottom: -${(p) => p.theme.spacing(1)};

  ${media.greaterThan('medium')`
    margin-bottom: 0;
    position: relative;
  `};
`
const CharacterScenePluggyImageAspectRatio = styled(AspectRatio)`
  margin: -${(p) => p.theme.spacing(-1)} auto -10vh;
  max-width: ${(p) => p.theme.spacing(7)};
  transform: translateX(-9%);
  width: 40%;

  ${media.greaterThan('medium')`
    flex-shrink: 0;
    margin: -${(p) => p.theme.spacing(0)} 0 0 ${(p) => p.theme.spacing(3)};
    max-width: none;
    width: 30%;
  `};
`

const CharacterScenePluggyImage = styled.img`
  width: 100%;
  height: 100%;
`

const CharacterScenePluggySpeechBubbleMobile = styled(SpeechBubble)`
  margin: 0 auto;

  ${media.greaterThan('medium')`
    display: none;
  `};
`

const CharacterScenePluggySpeechBubbleDesktop = styled(SpeechBubble)`
  display: none;
  margin: 0;
  position: absolute;
  right: ${(p) => p.theme.spacing(1)};
  top: 50%;
  transform: translateY(-50%);
  width: 50%;

  ${media.greaterThan('medium')`
    display: block;
  `};

  ${media.greaterThan('large')`
    right: -${(p) => p.theme.spacing(2)};
    width: 60%;
  `};
`

const CharacterSceneKeoni = styled(CharacterScene)`
  background: linear-gradient(125deg, #d881b5, #086c7b);
  padding-top: ${(p) => p.theme.spacing(4)};
  margin-bottom: -${(p) => p.theme.spacing(1)};

  ${media.greaterThan('medium')`
    margin-bottom: 0;
    padding-top: ${(p) => p.theme.spacing(3)};
    position: relative;
  `};
`

const CharacterSceneKeoniImageAspectRatio = styled(AspectRatio)`
  margin: 0 auto -5vh;
  transform: translateX(-4%);
  width: 50%;

  ${media.greaterThan('medium')`
    align-self: flex-end;
    flex-shrink: 0;
    margin: -${(p) => p.theme.spacing(4.5)} 0 0 ${(p) => p.theme.spacing(3)};
    max-width: none;
    width: 40%;
  `};
`

const CharacterSceneKeoniImage = styled.img`
  height: 100%;
  width: 100%;
`

const CharacterSceneKeoniSpeechBubbleMobile = styled(SpeechBubble)`
  position: relative;
  margin: 0 auto;
  z-index: 1;

  ${media.greaterThan('medium')`
    display: none;
  `};
`

const CharacterSceneKeoniSpeechBubbleDesktop = styled(SpeechBubble)`
  display: none;
  margin: 0;
  position: absolute;
  left: ${(p) => p.theme.spacing(1)};
  top: 50%;
  transform: translateY(-50%);
  width: 50%;

  ${media.greaterThan('medium')`
    display: block;
  `};

  ${media.greaterThan('large')`
    left: -${(p) => p.theme.spacing(2)};
    width: 60%;
  `};
`

const HouseScene = styled(CommonSpacing)`
  background: linear-gradient(to right, #155564, #274554);
  // background: linear-gradient(215deg, #317885, #274555);
  display: flex;
  flex-direction: column;
  position: relative;
  padding: 0;
  overflow: hidden;

  ${media.greaterThan('medium')`
    overflow: visible;
  `};
`

const HouseSceneBackgroundImage = styled.img`
  left: 0;
  opacity: 0.8;
  position: absolute;
  right: 0;
  top: 2%;
  width: 100%;
`

const HouseSceneImageAspectRatio = styled(AspectRatio)`
  margin: -${(p) => p.theme.spacing(2)} -15% 0;
  max-width: none;
  position: relative;
  width: 130%;
`

const HouseSceneImage = styled.img`
  height: 100%;
  width: 100%;
`

const LetsHelpButton = styled(Button)`
  align-self: center;
  margin: ${(p) => p.theme.spacing(3)} 0;
`

const HouseSceneSpeechBubble = styled(SpeechBubble)`
  margin: 0 auto;
`

export default class IndexPage extends Component {
  render() {
    return (
      <Preload items={preloadItems}>
        {() => (
          <Container>
            <HomeEnergyTips>
              <HomeEnergyTipsImage src={TextHomeEnergyTipsImage} />
            </HomeEnergyTips>
            <LearnHowToReduce>
              Learn how energy efficiency can save you money while helping
              Hawaii reach its 100% clean energy goals!
            </LearnHowToReduce>
            <InView>
              {({ inView, ref }) => (
                <CharacterScenePluggy innerRef={ref}>
                  <CharacterScenePluggyImageAspectRatio
                    width={97.42}
                    height={187}
                  >
                    <CharacterScenePluggyImage
                      src={CharacterPluggyForwardImage}
                    />
                  </CharacterScenePluggyImageAspectRatio>
                  <CharacterScenePluggySpeechBubbleDesktop
                    heading="Aloha Energy Saver!"
                    position="right"
                    showAnimation={inView}
                  >
                    <p>
                      I'm Pluggy and I'll be your{' '}
                      <em>FRIENDLY HOME ENERGY ADVISOR.</em>
                    </p>
                  </CharacterScenePluggySpeechBubbleDesktop>
                  <CharacterScenePluggySpeechBubbleMobile
                    heading="Aloha Energy Saver!"
                    position="bottom"
                    showAnimation={inView}
                  >
                    <p>
                      I'm Pluggy and I'll be your{' '}
                      <em>FRIENDLY HOME ENERGY ADVISOR.</em>
                    </p>
                  </CharacterScenePluggySpeechBubbleMobile>
                </CharacterScenePluggy>
              )}
            </InView>
            <InView>
              {({ inView, ref }) => (
                <CharacterSceneKeoni innerRef={ref}>
                  <CharacterSceneKeoniImageAspectRatio width={483} height={855}>
                    <CharacterSceneKeoniImage src={CharacterKeoniBillImage} />
                  </CharacterSceneKeoniImageAspectRatio>
                  <CharacterSceneKeoniSpeechBubbleDesktop
                    position="bottom"
                    pointerPosition="45%"
                    showAnimation={inView}
                  >
                    <p>This is Keoni.</p>
                    <p>
                      Let's help him identify ways to <em>save money</em> on his
                      electric bill, while contributing to a <em>cleaner</em>{' '}
                      and more <em>resilient</em> future for Hawaii!
                    </p>
                  </CharacterSceneKeoniSpeechBubbleDesktop>
                  <CharacterSceneKeoniSpeechBubbleMobile
                    position="bottom"
                    showAnimation={inView}
                    showPointer={false}
                  >
                    <p>This is Keoni.</p>
                    <p>
                      Let's help him identify ways to <em>save money</em> on his
                      electric bill, while contributing to a <em>cleaner</em>{' '}
                      and more <em>resilient</em> future for Hawaii!
                    </p>
                  </CharacterSceneKeoniSpeechBubbleMobile>
                </CharacterSceneKeoni>
              )}
            </InView>
            <InView>
              {({ inView, ref }) => (
                <HouseScene innerRef={ref}>
                  <HouseSceneBackgroundImage src={HouseBackgroundImage} />
                  <HouseSceneImageAspectRatio width={2182} height={2073}>
                    <HouseSceneImage src={HouseCharactersImage} />
                  </HouseSceneImageAspectRatio>
                  <HouseSceneSpeechBubble
                    heading="Thanks for helping!"
                    position="bottom"
                    showAnimation={inView}
                  >
                    <p>Let's head inside!</p>
                  </HouseSceneSpeechBubble>
                  <LetsHelpButton to="/age/" size="large">
                    Let's Help
                  </LetsHelpButton>
                </HouseScene>
              )}
            </InView>
          </Container>
        )}
      </Preload>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/index.js